import { render } from "./ProgressBar.vue?vue&type=template&id=4120451b"
import script from "./ProgressBar.vue?vue&type=script&lang=js"
export * from "./ProgressBar.vue?vue&type=script&lang=js"
script.render = render

export default script